import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[appPopupModalHost]',
})
export class PopupModalHostDirective {
  readonly viewContainerRef = inject(ViewContainerRef);
}
